import _ from "lodash";

export const transformToApiRequestBody = (obj: any) => {
    return _.mapKeys(obj, (v, k) => _.kebabCase(k));
}
